import { ElementRef } from "@angular/core";
import { IdDescriptionItem } from "@se/models";
export class Suggestion {
    id: number;
    guid?: string;
    Sentence: { [key: string]: string };
    Description: string;
    IsNormality?: boolean;
    code: string;
    newLineAfter?: boolean;
    groupNameHashCode?: number;
    modalities?: Array<IdDescriptionItem>;
    standardModalities?: Array<IdDescriptionItem>;
    groupName?: string | null;
    groupDescription?: string | null;
    referringPhysician?: User;
    label?: string;
    isStandard?: boolean; //bool per standardModules
    modules?: Array<IdDescriptionItem>;
    standardModules?: Array<IdDescriptionItem>;
}

export interface ExtendedSuggestion {
    suggestion: Suggestion;
    policy: boolean;
}

export interface User {
    id: string;
    description?: string;
    employeeSerialNumber?: string;
    isAuthorized?: boolean;
}

export interface SaveExtendedSuggestionEvent {
    index: number;
    suggestions: Suggestion[];
    fromDefaultTextName: string;
    groupNameHashCode: number;
    isNew: boolean;
    toDelete: boolean;
}

export enum PolicySuggestion {
    Concatenate,
    Replace
}

export class CpControlSuggestions {
    idControl: string;
    defaultName: string;
    defaultGroup: string;
    model: string;
    groupHashCode: number | null;
    referringPhysician?: User;
    idComponent?: ElementRef<any>;
    label?: string;
    

    constructor(idControl: string, defaultName: string, defaultGroup: string, model: string, groupHashCode: number | null, referringPhysician?: User, idComponent?: ElementRef<any>, label?: string) {
        this.idControl = idControl;
        this.defaultName = defaultName;
        this.defaultGroup = defaultGroup;
        this.model = model;
        this.groupHashCode = groupHashCode;
        this.referringPhysician = referringPhysician;
        this.idComponent = idComponent;
        this.label = label;
    }
}
